<div class="mt-8 flex flex-col items-center gap-3" *transloco="let t">
  <div class="w-3/4">
    <span class="text-xs text-gray-400">3/3</span>
    <div class="mb-4 text-xl font-semibold text-gray-700">
      {{ t("free-test-subscription-page.start_my_free_test_heading") }}
    </div>
    <p class="text-gray-700">{{ t("free-test-subscription-page.start_my_free_test_subheading") }}</p>
    @if (belowFreeTestAdSpendThreshold()) {
      <div
        class="my-4 flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-4 py-2 text-sm text-gray-600"
      >
        <IIcon name="infoCircle" /><span>{{ t("free-test-subscription-page.start_my_free_test_warning") }}</span>
      </div>
      <div class="mt-8 flex flex-col items-center gap-3">
        <button iButton size="md" (click)="openFreeTestModal()" class="shadow">
          {{ t("common.start_free_test_cta") }} <IIcon name="arrowRight" />
        </button>
        <a class="cursor-pointer text-sm text-gray-500 hover:text-gray-600" (click)="skipOnboarding()">{{
          t("common.i_will_do_it_later")
        }}</a>
      </div>
    } @else if (belowFreeTestAdSpendThreshold() === false) {
      <div class="my-8 flex flex-col items-center gap-3">
        <button iButton size="md" (click)="openFreeTestModal()">{{ t("common.start_free_test_cta") }}</button>
        <a class="cursor-pointer text-gray-400 hover:text-gray-500" (click)="skipOnboarding()">{{
          t("common.i_will_do_it_later")
        }}</a>
      </div>
      <div class="mb-4 flex items-center font-semibold">
        <IIcon name="warningTriangle" class="mr-2 text-lg text-orange-500" />
        <span>{{ t("free-test-subscription-page.start_my_free_test_warning") }}</span>
      </div>
    }
  </div>

  @if (belowFreeTestAdSpendThreshold()) {
    <div
      class="mt-12 flex w-3/4 flex-col gap-4 rounded-lg border border-slate-200 bg-slate-50 p-4 text-slate-800"
      role="alert"
    >
      <div class="flex items-center">
        <div class="flex items-center text-lg font-medium">
          <IIcon name="lightbulb" class="mr-2" />{{ t("free-test-subscription-page.good_to_know") }}
        </div>
      </div>
      <div>
        <p [innerHTML]="t('free-test-subscription-page.autopilot_ad')"></p>
        <p>
          {{ t("free-test-subscription-page.autopilot_ad_2") }}
        </p>
      </div>
      <div class="flex flex-col items-center justify-center gap-3">
        <a iButton variant="secondary" href="https://autopilot.m19.com" target="_blank" size="md">
          {{ t("free-test-subscription-page.try_autopilot_instead") }}
        </a>
        @if (autopilotMonthlyFee(); as autopilotMonthlyFee) {
          <div class="flex items-start">
            <div class="text-sm text-gray-500">
              {{ t("free-test-subscription-page.pricing_autopilot", { price: autopilotMonthlyFee }) }}
            </div>
          </div>
        }
        <a
          class="text-main-600 hover:text-main-800 text-sm"
          href="https://www.m19.com/products/product-autopilot"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ t("free-test-subscription-page.learn_more") }}
        </a>
      </div>
    </div>
  }
</div>
<ng-template #accountSelection *transloco="let t">
  <div class="flex max-h-full flex-col gap-4 overflow-hidden">
    <div class="space-y-2 text-sm text-gray-500">
      <div>{{ t("onboarding.start_ads_auto_info") }}</div>
      <div>{{ t("onboarding.start_ads_auto_info_2") }}</div>
      <div class="mt-2">{{ t("onboarding.start_free_test_disclaimer") }}</div>
    </div>
    <hr class="my-4 border-gray-200" />
    <div class="min-h-0 flex-1 shrink-0 p-1">
      <app-select-accounts-page
        [accountMarketplaces]="accountMarketplaces()!"
        [disabledAccountsMarketplaces]="disabledAccountsMarketplaces()"
        [orgId]="organization()!.organizationId!"
        (selectionChange)="selectedAccountMarketplaces.set($event)"
      />
    </div>
    <div class="mt-2 flex justify-end gap-4">
      <button iButton variant="secondary" size="md" (click)="accountSelectionModalRef()?.close()">
        {{ t("common.cancel") }}
      </button>
      <button
        iButton
        size="md"
        (click)="activateFreeTest()"
        [loading]="activatingFreeTest()"
        [disabled]="selectedAccountMarketplaces().length === 0"
      >
        {{ t("common.start_free_test_cta") }}
      </button>
    </div>
  </div>
</ng-template>
